var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      attrs: {
        "data-test": "speed-control",
        title: _vm.$t(
          _vm.a11y(_vm.nextRate * 100).key,
          _vm.a11y(_vm.nextRate * 100).attr
        )
      },
      on: {
        click: _vm.setRate,
        dblclick: function($event) {
          return _vm.setRate(1)
        }
      }
    },
    [
      _c("icon", {
        attrs: {
          "aria-hidden": "true",
          type: _vm.icon,
          color: _vm.color,
          "data-test": "speed-control--" + _vm.icon
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }